import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class HomeRoute extends Route {
  @service
  options;

  @service
  students;

  beforeModel() {
    // <Enrolment::NzMoe::PendingUploadNotification> and the hub menu badges
    // render from students.numPending{Enrolments,Unenrolments}. This route
    // asks for the counts rather than a getter fetching them as a side effect
    // of being rendered.
    if (this.options.value('hero:nzMOE:enrolArrivalsLeaversEnabled')) {
      this.students.loadPendingUploads();
    }
  }
}
